module.exports = __webpack_public_path__ + "img/icon historial propuestas.3d9f0473.svg";